/**
 * Brand Carousel – marquee animation
 *
 * Uses CSS animation only (no Swiper). The marquee keyframe is defined in
 * src/sass/blocks/acf/_brand-carousel.sass. Pauses on hover for readability.
 */

import Swiper from 'swiper';
import { Autoplay, FreeMode} from 'swiper/modules';

const brandSwiper = new Swiper('.brand-slider',{
  modules: [Autoplay, FreeMode],
  spaceBetween: 0,
  slidesPerView: 'auto',
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  freeMode: true,

});
